import { withRouter } from 'react-router-dom'
import React from 'react'
import { connect } from 'react-redux'
import { getCompanyLogoUrl, getHostCompanyId } from '../utils/Tools'

const mapStateToProps = state => ({
  orderCompanyId: (state.rma && state.rma.order && state.rma.order.logo_company_id) || false
})

class HeaderComponent extends React.Component {

  getLogoStyle() {
    const companyId = this.props.orderCompanyId || getHostCompanyId()
    if (!companyId) {
      return undefined
    }
    return { backgroundImage: `url(${getCompanyLogoUrl(companyId)})` }
  }

  render() {
    const {showLogo} = this.props
    return(
      <header>
        <div className={`logo${showLogo ? '' : ' is-hidden'}`} style={this.getLogoStyle()}/>
      </header>
    )
  }
}
const Header = connect(mapStateToProps, null)(HeaderComponent)

export default withRouter(Header)
